import {mapValues} from 'lodash'
import presignedExport from '../../../services/auth/presignedExport';
import {hasLocationScheduling} from "../../../modules/app/site/featureAccessControl";

(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.locations', [
    'clientDashboardApp.admin.locations.locationsManagerService'
  ]).controller("LocationsManagerCtrl", LocationsManagerCtrl);

  LocationsManagerCtrl.$inject = ['$scope', '$state', '$q', '$location', '$stateParams', 'locationsManagerService', 'pagingService', 'userService', 'locationService', 'accountId', 'configService','adminSearchService','updateService', 'stringService', 'confirmService'];

  function LocationsManagerCtrl($scope, $state, $q, $location, $stateParams, locationsManagerService, pagingService, userService, locationService, accountId, configService, adminSearchService, updateService, stringService, confirmService) {
    const vm = this;

    vm.hasLocationScheduling = hasLocationScheduling();

    vm.updateService = updateService;

    vm.locationSearchQuery = adminSearchService.getSearchQuery()
    vm.showDeactivatedLocations = false

    vm.pagingOptions = {
      limit: '25',
      currentPage : 1,
      sortField : "businessName",
      sortOrder : "ASC"
    }

    vm.sortOptions = {
      field: [
        {name:'Client Location Id',id:'clientLocationId'},
        {name:'Business Name',id:'businessName'},
        {name:'Street',id:'businessAddress.street'},
        {name:'Suite',id:'businessAddress.suite'},
        {name:'City',id:'businessAddress.city'},
        {name:'State',id:'businessAddress.state'},
        {name:'Zip',id:'businessAddress.postalCode'},
        {name:'Account',id:'account'}
      ],
      order: [
        {name:'Ascending',id:'ASC'},
        {name:'Descending',id:'DESC'}
      ],
      limit: [
        {name:'10',id:'10'},
        {name:'25',id:'25'},
        {name:'50',id:'50'},
        {name:'100',id:'100'}
      ]
    }

    vm.accountSelected = false;
    vm.totalLocationsInResponse = null;
    vm.loadingLocations = true;
    vm.freshQuery = null;

    vm.state = {
      updating: false
    };

    vm.pageStrings = stringService.adminStrings();

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    };

    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: true
    };

    vm.refreshLocations = function () {
      vm.loadingLocations = true;
      vm.locationSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.locationSearchQuery;
      handleUpdateResponse();
    };

    vm.notificationSettings = [
      {
        id: 'newReviewAlerts',
        key: 'newReviewAlerts',
        name: 'Review Alerts',
        displayType: 'checkbox'
      },
      {
        id: 'pdfSummaryReports',
        key: 'pdfSummaryReports',
        name: 'PDF Reports',
        displayType: 'checkbox'
      }
    ].map( column => ({...column,showIf: vm.showEditLocation,onChange: (notifications,id) => vm.updatedSetting(notifications.locationId, id, notifications[id])}));

    vm.columns = [
      {
        id : 'active',
        key: 'isActiveLocation',
        name: 'Active',
        displayType: 'checkbox',
        show: () => vm.showDeactivateLocation
      },
      {
        id : 'status',
        name: 'Status',
        sortId: 'subscriptionType',
        key: 'subscriptionType',
        displayType: 'text',
        show: () => vm.showSubscriptionType
      },
      {
        id : 'locationId',
        key: 'locationId',
        name: 'Location Id',
        sortId: 'locationId',
        displayType: 'text',
        show: () => (true)
      },      {
        id : 'clientLocationId',
        key: 'clientLocationId',
        sortId: 'clientLocationId',
        name: 'Client Location Id',
        displayType: 'text',
        show: () => (true)
      },
      {
        id : 'account',
        name: 'Account',
        key: (notifications) => (notifications.accountId),
        sortId: 'account.name',
        displayType: 'text',
        baseObject: () => (vm.accountConfig.accountNames),
        show: () => vm.accountConfig.hasMultipleAccounts
      },
      {
        id : 'businessName',
        sortId: 'businessName',
        key: 'businessName',
        name: 'Business Name',
        displayType: 'text',
      },
      {
        id : 'street',
        key: 'businessAddress.street',
        sortId: 'businessAddress.street',
        name: 'Street',
        displayType: 'text',
      },
      {
        id : 'city',
        key: 'businessAddress.city',
        sortId: 'businessAddress.city',
        name: 'City',
        displayType: 'text',
      },
      {
        id : 'state',
        key: 'businessAddress.state',
        sortId: 'businessAddress.state',
        name: 'State',
        displayType: 'text',
      },
      {
        id : 'zip',
        key: 'businessAddress.postalCode',
        sortId: 'businessAddress.postalCode',
        name: 'Zip',
        displayType: 'text'
      },
      ...vm.notificationSettings,
      {
        id : 'actions',
        name: 'Actions',
        displayType: 'buttons',
        actions: [
          {
            onClick: (notifications) => vm.refreshLocation(notifications.locationId),
            show: () => (true),
            tooltip: (notifications) => !notifications.isDeleted ? "Refresh Location" : "Activate location to refresh location.",
            iconClass: "far fa-sync-alt",
          },
          {
            onClick: (notifications) => $state.go('admin_v2.location.competitors',{locationId:notifications.locationId}),
            show: () => (vm.showEditCompetitor),
            tooltip: (notifications) => !notifications.isDeleted ? "Edit Competitors" : "Activate location to edit competitors.",
            iconClass: "fas fa-binoculars",
          },
          {
            onClick: (notifications) => $location.path("/admin/v2/locations/" + notifications.locationId + "/editNew"),
            show: () => (vm.showEditLocation),
            tooltip: (notifications) => !notifications.isDeleted ? "Edit Location Details" : "Activate location to edit location details.",
            iconClass: "fas fa-pencil",
            style: {position:"relative", top:"3px"}
          }
        ].map(action => ({...action,disabled: (notifications) => (notifications.isDeleted)}))
      }
    ]

    vm.updateSort = (column) => {
      if(column.sortId){
        let alreadyClicked = vm.pagingOptions.sortField === column.sortId
        vm.pagingOptions.sortField = column.sortId
        if(alreadyClicked){
          vm.pagingOptions.sortOrder = vm.pagingOptions.sortOrder === "ASC" ? "DESC" : "ASC"
        }
        else {
          vm.pagingOptions.sortOrder = "ASC"
        }
        vm.loadNotificationSettings()
      }
    }

    vm.getSortIcon = (column) => {
      let classStr = ""
      if(column.sortId){
        if(vm.pagingOptions.sortField === column.sortId){
          classStr = vm.pagingOptions.sortOrder === "ASC" ? "fa-sort-up" : "fa-sort-down"
        } else {
          classStr = "fa-sort"
        }
      }
      return classStr
    }

    vm.resetColumns = () => {
      vm.columns = vm.columns.map(column => ({...column, hide: false}))
    }

    vm.hasHiddenColumns = () => {
      return vm.columns.reduce((acc, item) => (acc || item.hide),false)
    }

    vm.hideColumn = (column) => {
      column.hide = true
    }

    vm.totalVisibleColumns = () => {
      return vm.columns.filter(column => ((column.show && column.show() || !column.show) && !column.hide)).length
    }

    vm.getValue = (obj,accessor) => { /* dynamic nested field access */
      let keys = accessor.split('.')
      let myObj = obj[keys[0]]
      if(keys.length > 1) {
        return vm.getValue(myObj,keys.slice(1,keys.length).join('.'))
      }
      else {
        return myObj || "N/A"
      }
    }

    vm.functionOrValue = (item,param) => {
      return typeof item === 'function' ? item(param) : item
    }

    const resetPage = () => {
      vm.submitted = false
      vm.locationSummaries = []
      vm.locationNotificationSettings = []
      vm.notificationChanges = []
    };
    // Set defaults
    resetPage();

    vm.updatedSetting = function (locationId, settingId, newValue) {
      vm.notificationChanges.push({locationId: locationId, settingId: settingId, newValue: newValue})
    };

    const getLocationsToDeactivate = () => vm.locationNotificationSettings
        .filter(location => location['originalIsActiveLocation'] !== location['isActiveLocation'] && location['isActiveLocation'] === false)

    const getLocationsToActivate = () => vm.locationNotificationSettings
        .filter(location => location['originalIsActiveLocation'] !== location['isActiveLocation'] && location['isActiveLocation'] === true)

    vm.hasPendingChanges = () => (vm.notificationChanges.length + getLocationsToDeactivate().length + getLocationsToActivate().length) > 0

    const handleUpdateResponse = function () {
      if (vm.hasPendingChanges()){
        let actions = [];
        let locationsModified = _.map(_.countBy(vm.notificationChanges,'locationId'),function(val,key){
          return {id: Number(key)}
        }).length;
        if(getLocationsToDeactivate().length) {
          actions.push({name: "Location", action: "deactivate", count: getLocationsToDeactivate().length});
        }
        if(getLocationsToActivate().length) {
          actions.push({name: "Location", action: "activate", count: getLocationsToActivate().length});
        }
        if(vm.notificationChanges.length) {
          actions.push({name: "Notification", action: "edit", count: vm.notificationChanges.length});
        }
        let updateInfo = {
          status: "Active",
          type: "location",
          title: "Location",
          actions: actions,
          destinationRole: "manage",
          notificationType: "total",
          totalUpdates:  locationsModified + getLocationsToDeactivate().length + getLocationsToActivate().length
        }
        updateService.registerSuccessfulUpdate(updateInfo);
        vm.state.updating = false;
        $state.reload();
      }
      resetPage();
      vm.loadNotificationSettings()
    };

    var prepNotificationSettings = function (resp) {
      var mappedLocations = _.map(resp.data.locationSummaries, locationService.formatLocation);
      var locationSummaries = _.indexBy(mappedLocations, 'locationId');
      var notificationSettings = resp.data.notificationSettings;

      vm.locationsResponse = resp.data;
      vm.totalLocationsInResponse = notificationSettings.length;
      vm.totalResults = resp.data.count
      let count = 0
      vm.locationNotificationSettings = resp.data.locationSummaries.map( item => {
          let summaryItem = locationSummaries[item.locationId]
          let alertSettings = notificationSettings.find(setting => setting.locationId === summaryItem.locationId)
          if(summaryItem._deleted) count++
          const clientLocationId =  !!item && !!item.locationIdForDisplay ? item.locationIdForDisplay : item.resellerLocId;
          return {
            ...item,
            ...alertSettings,
            ...summaryItem,
            clientLocationId,
            _deleted: summaryItem._deleted,
            accountId: summaryItem.accountId,
            isActiveLocation: !summaryItem.notActiveLocation,
            originalIsActiveLocation: !summaryItem.originalNotActiveLocation,
            locationSummary: summaryItem.summary,
            isDeleted: summaryItem.isDeleted,
          }
        }
      )

      if(vm.updateConfig.entityId){
        if(_.where(vm.locationNotificationSettings,{id:vm.updateConfig.entityId}).length>0){
          vm.updateConfig.pageOneResult = true;
        }
      }

      vm.loadingLocations = false;
    };


    vm.submitChanges = function (formIsValid) {
      vm.state.updating = true;
      if (!vm.hasPendingChanges) {
        $log.warn('No changes to submit');
      }

      vm.submitted = true;
      vm.loadingLocations = true;
      const locationsToDeactivate = getLocationsToDeactivate();
      const locationsToActivate = getLocationsToActivate();
      var promises = [];
      var onUpdateFinished = function () {
        vm.state.updating = false;
        vm.loadingLocations = false;
      };

      var updateNotificationChangesIfNeeded = function() {
        //Api call to back end
        if (vm.notificationChanges.length > 0) {
          promises.push(promises.updateNotifications = locationsManagerService.updateNotificationSettings(vm.notificationChanges));
        }
      };

      if (locationsToDeactivate.length > 0 || locationsToActivate.length > 0) {
        let message = ""
          if (locationsToDeactivate.length > 0) {
              message = message + "Are you sure that you want to deactivate " + (locationsToDeactivate.length === 1 ? "this location?" : "these " + locationsToDeactivate.length +" locations?") + "<br>"
              message = message + "<ol>" + locationsToDeactivate.map(location => "<li>" + location.locationSummary + "</li>").join("") + "</ol>"
              if (locationsToActivate.length > 0) {
                // Add a new line if we also have locations to activate
                message = message + "<br>"
              }
          }
          if (locationsToActivate.length > 0) {
              message = message + "Are you sure that you want to activate " + (locationsToActivate.length === 1 ? "this location?" : "these " + locationsToActivate.length +" locations?") + "<br>"
              message = message + "<ol>" + locationsToActivate.map(location => "<li>" + location.locationSummary + "</li>").join("") + "</ol>"
          }
        return confirmService
          .confirm("Confirm Changes", message, confirmService.WARNING)
          .then(function (result) {
            if (result) {
              updateNotificationChangesIfNeeded();
              if (locationsToDeactivate.length > 0) {
                promises.push(locationsManagerService.deactivateLocations(locationsToDeactivate.map(l => l.locationId)))
              }
              if (locationsToActivate.length > 0) {
                promises.push(locationsManagerService.activateLocations(locationsToActivate.map(l => l.locationId)))
              }
              return $q.all(promises).then(handleUpdateResponse, onUpdateFinished)
            }
            vm.submitted = false;
            onUpdateFinished();
          })
      }
      updateNotificationChangesIfNeeded();
      $q.all(promises).then(handleUpdateResponse, onUpdateFinished);
    };

    vm.cancelChanges = function () {
      vm.loadingLocations = true;
      resetPage();
      vm.loadNotificationSettings()
    };

    vm.loadNotificationSettings = () => {
      vm.loadingLocations = true
      locationsManagerService.getLocationNotificationSettings(vm.accountConfig.accountId, vm.locationSearchQuery, vm.showDeactivatedLocations, {...vm.pagingOptions, offset: vm.pagingOptions.limit * (vm.pagingOptions.currentPage - 1) }).then(prepNotificationSettings);
    }

    vm.refreshLocation = function (locationId) {
      vm.locationRefreshStatus = 'pending';

      $('#refreshLocationModal').modal();
      locationsManagerService.refreshLocation(locationId).then(
        function () {
          vm.locationRefreshStatus = 'complete';
        }, function () {
          vm.locationRefreshStatus = 'failed';
        });
    };

    userService.currentUser().then(function (userInfo) {
      var permissions = userInfo.permissions;
      var hideEditLocations;
      configService.getBrandConfig(false).then(function(data){
        hideEditLocations = data.restrictions.hideEditLocationsForStandardUsers && userInfo.userType == "Standard";
        vm.showSubscriptionType = userInfo.userType === "ResellerAdmin"
        vm.showAddLocation = _.contains(permissions, 'AddLocation');
        vm.showEditLocation = _.contains(permissions, 'EditLocation') && !hideEditLocations;
        vm.showEditCompetitor = _.contains(permissions, 'EditLocation');
        vm.showDeactivateLocation = _.contains(permissions, 'DeleteLocation');
        vm.showActivateLocation = _.contains(permissions, 'RestoreLocation');
      });
    });

    vm.gotoLocationEditor = function(opType,notifications){
      if(opType=="create"){
        $location.path("admin/v2/locations/create");
      }
      else if(opType=="edit"){
        $location.path("admin/v2/locations/"+notifications.locationId+"/edit");
      }
    }

    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    }

    $scope.$watch('vm.accountConfig.accountId',function(newVal,oldVal) {
      if(oldVal !== newVal){
        vm.refreshLocations();
      }
    });

    $scope.$watch('vm.adminConfirmConfig.refresh',function(newVal,oldVal){
      if(oldVal !== newVal && newVal === true){
        vm.refreshLocations();
      }
    })

    vm.getAccountId = () => {
      return vm.accountConfig.accountId === "all" ? "" : vm.accountConfig.accountId;
    }

    vm.exportingLocations = false;
    vm.exportingGroups = false;
    vm.exportingCompetiors = false;

    vm.exportLocations = () => {
      if(vm.exportingLocations) return;
      vm.exportingLocations = true;
      presignedExport.downloadExport(
        '/v5/export/locations',
        {
          accountId: vm.getAccountId(),
          locationQuery: vm.locationSearchQuery,
          includeDeletedLocations: vm.showDeactivatedLocations
        }
      ).then((resp) => {
        vm.exportingLocations = false;
        return resp;
      });
    }

    vm.exportGroups = () => {
      if(vm.exportingGroups) return;
      vm.exportingGroups = true;
      presignedExport.downloadExport('/v5/export/groupsToLocations', {accountId: vm.getAccountId() }).then((resp) => {
        vm.exportingGroups = false;
        return resp;
      });
    }

    vm.exportCompetitors = () => {
      if(vm.exportingCompetiors) return;
      vm.exportingCompetiors = true;
      presignedExport.downloadExport(
        '/v5/export/competitor',
        {
          accountId: vm.getAccountId(),
          locationQuery: vm.locationSearchQuery,
          includeDeletedLocations: vm.showDeactivatedLocations
        }
      ).then((resp) => {
        vm.exportingCompetiors = false;
        return resp;
      });
    }

  }
})();
